<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">Ricevuta</span>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    aria-label="Chiudi"
    class="close-button"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="receipt-content">
  <div class="receipt-confirmation">
    <div class="receipt-confirmation-icon" aria-hidden="true">
      <i class="fa-regular fa-check"></i>
    </div>

    <span class="title-medium-emphasized">Distinta confermata</span>

    <span class="receipt-confirmation-message body-small">
      La riconciliazione degli incassi verrà effettuata il giorno successivo.
    </span>
  </div>

  <div class="deposit-receipt-card">
    <div class="deposit-receipt-row">
      <span class="body-small">Distinta N°</span>
      <span class="body-small-emphasized">{{ data.numeroDistinta }}</span>
    </div>

    <div class="deposit-receipt-row">
      <span class="body-small">Data conferma</span>
      <span class="body-small-emphasized">{{ data.dataConferma | date: 'dd/MM/yyyy' }}</span>
    </div>

    <div class="deposit-receipt-row">
      <span class="body-small">Totale contanti</span>
      <span class="body-small-emphasized">{{ formatAmount(data.totaleContanti) }}</span>
    </div>

    <div class="deposit-receipt-row">
      <span class="body-small">Totale assegni</span>
      <span class="body-small-emphasized">{{ formatAmount(data.totaleAssegni) }}</span>
    </div>

    <div class="deposit-receipt-row">
      <span class="body-small">Totale assegni</span>
      <span class="body-small-emphasized">{{ formatAmount(data.totaleAssegni) }}</span>
    </div>

    <div class="deposit-receipt-divider"></div>

    <div class="deposit-receipt-row deposit-receipt-total">
      <span>Totale distinta</span>
      <span>{{ formatAmount(data.totaleDistinta) }}</span>
    </div>

    <div class="deposit-receipt-divider"></div>

    <div class="deposit-receipt-row">
      <span class="body-small">Stato</span>
      <span class="body-small-emphasized">{{ data.situazione }}</span>
    </div>
  </div>

  <div class="deposit-receipt-info">
    <div class="deposit-receipt-info-icon" aria-hidden="true">
      <i class="fa-solid fa-circle-info"></i>
    </div>

    <span class="deposit-receipt-info-text body-medium">
      La riconciliazione avverrà automaticamente il giorno lavorativo successivo. Riceverai una notifica al completamento.
    </span>
  </div>
</mat-dialog-content>
